module.exports = __webpack_public_path__ + "static/default-31f1ecac0497afcf318b01e8828a3e8c.png";